var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItEssentialsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20H22C21.4477 20 21 20.4477 21 21V29C21 29.5523 21.4477 30 22 30H30C30.5523 30 31 29.5523 31 29V21C31 20.4477 30.5523 20 30 20ZM22 19C20.8954 19 20 19.8954 20 21V29C20 30.1046 20.8954 31 22 31H30C31.1046 31 32 30.1046 32 29V21C32 19.8954 31.1046 19 30 19H22Z",
    fill: "#F747C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1992 15C29.4754 15 29.6992 15.2239 29.6992 15.5L29.6992 17.5C29.6992 17.7761 29.4754 18 29.1992 18C28.9231 18 28.6992 17.7761 28.6992 17.5L28.6992 15.5C28.6992 15.2239 28.9231 15 29.1992 15Z",
    fill: "#F747C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1992 32C29.4754 32 29.6992 32.2239 29.6992 32.5L29.6992 34.5C29.6992 34.7761 29.4754 35 29.1992 35C28.9231 35 28.6992 34.7761 28.6992 34.5L28.6992 32.5C28.6992 32.2239 28.9231 32 29.1992 32Z",
    fill: "#F747C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0391 15C27.3152 15 27.5391 15.2239 27.5391 15.5L27.5391 17.5C27.5391 17.7761 27.3152 18 27.0391 18C26.7629 18 26.5391 17.7761 26.5391 17.5L26.5391 15.5C26.5391 15.2239 26.7629 15 27.0391 15Z",
    fill: "#F747C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0391 32C27.3152 32 27.5391 32.2239 27.5391 32.5L27.5391 34.5C27.5391 34.7761 27.3152 35 27.0391 35C26.7629 35 26.5391 34.7761 26.5391 34.5L26.5391 32.5C26.5391 32.2239 26.7629 32 27.0391 32Z",
    fill: "#F747C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8828 15C25.159 15 25.3828 15.2239 25.3828 15.5L25.3828 17.5C25.3828 17.7761 25.159 18 24.8828 18C24.6067 18 24.3828 17.7761 24.3828 17.5L24.3828 15.5C24.3828 15.2239 24.6067 15 24.8828 15Z",
    fill: "#F747C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8828 32C25.159 32 25.3828 32.2239 25.3828 32.5L25.3828 34.5C25.3828 34.7761 25.159 35 24.8828 35C24.6067 35 24.3828 34.7761 24.3828 34.5L24.3828 32.5C24.3828 32.2239 24.6067 32 24.8828 32Z",
    fill: "#F747C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7227 15C22.9988 15 23.2227 15.2239 23.2227 15.5L23.2227 17.5C23.2227 17.7761 22.9988 18 22.7227 18C22.4465 18 22.2227 17.7761 22.2227 17.5L22.2227 15.5C22.2227 15.2239 22.4465 15 22.7227 15Z",
    fill: "#F747C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7227 32C22.9988 32 23.2227 32.2239 23.2227 32.5L23.2227 34.5C23.2227 34.7761 22.9988 35 22.7227 35C22.4465 35 22.2227 34.7761 22.2227 34.5L22.2227 32.5C22.2227 32.2239 22.4465 32 22.7227 32Z",
    fill: "#F747C0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 28.4474C36 28.7235 35.7761 28.9474 35.5 28.9474L33.5 28.9474C33.2239 28.9474 33 28.7235 33 28.4474C33 28.1712 33.2239 27.9474 33.5 27.9474L35.5 27.9474C35.7761 27.9474 36 28.1712 36 28.4474Z",
    fill: "#F747C0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 28.4474C18.9883 28.7235 18.7644 28.9474 18.4883 28.9474L16.4883 28.9474C16.2121 28.9474 15.9883 28.7235 15.9883 28.4474C15.9883 28.1712 16.2121 27.9474 16.4883 27.9474L18.4883 27.9474C18.7644 27.9474 18.9883 28.1712 18.9883 28.4474Z",
    fill: "#F747C0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 26.2895C36 26.5656 35.7761 26.7895 35.5 26.7895L33.5 26.7895C33.2239 26.7895 33 26.5656 33 26.2895C33 26.0133 33.2239 25.7895 33.5 25.7895L35.5 25.7895C35.7761 25.7895 36 26.0133 36 26.2895Z",
    fill: "#F747C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 26.2895C18.9883 26.5656 18.7644 26.7895 18.4883 26.7895L16.4883 26.7895C16.2121 26.7895 15.9883 26.5656 15.9883 26.2895C15.9883 26.0133 16.2121 25.7895 16.4883 25.7895L18.4883 25.7895C18.7644 25.7895 18.9883 26.0133 18.9883 26.2895Z",
    fill: "#F747C0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 24.1316C36 24.4077 35.7761 24.6316 35.5 24.6316L33.5 24.6316C33.2239 24.6316 33 24.4077 33 24.1316C33 23.8554 33.2239 23.6316 33.5 23.6316L35.5 23.6316C35.7761 23.6316 36 23.8554 36 24.1316Z",
    fill: "#F747C0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 24.1316C18.9883 24.4077 18.7644 24.6316 18.4883 24.6316L16.4883 24.6316C16.2121 24.6316 15.9883 24.4077 15.9883 24.1316C15.9883 23.8554 16.2121 23.6316 16.4883 23.6316L18.4883 23.6316C18.7644 23.6316 18.9883 23.8554 18.9883 24.1316Z",
    fill: "#F747C0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 21.9737C36 22.2498 35.7761 22.4737 35.5 22.4737L33.5 22.4737C33.2239 22.4737 33 22.2498 33 21.9737C33 21.6976 33.2239 21.4737 33.5 21.4737L35.5 21.4737C35.7761 21.4737 36 21.6976 36 21.9737Z",
    fill: "#F747C0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 21.9737C18.9883 22.2498 18.7644 22.4737 18.4883 22.4737L16.4883 22.4737C16.2121 22.4737 15.9883 22.2498 15.9883 21.9737C15.9883 21.6976 16.2121 21.4737 16.4883 21.4737L18.4883 21.4737C18.7644 21.4737 18.9883 21.6976 18.9883 21.9737Z",
    fill: "#F747C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8708_63937)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_8708_63937)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_8708_63937)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_8708_63937)",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_8708_63937)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20H22C21.4477 20 21 20.4477 21 21V29C21 29.5523 21.4477 30 22 30H30C30.5523 30 31 29.5523 31 29V21C31 20.4477 30.5523 20 30 20ZM22 19C20.8954 19 20 19.8954 20 21V29C20 30.1046 20.8954 31 22 31H30C31.1046 31 32 30.1046 32 29V21C32 19.8954 31.1046 19 30 19H22Z",
    fill: "#F747C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1992 15C29.4754 15 29.6992 15.2239 29.6992 15.5L29.6992 17.5C29.6992 17.7761 29.4754 18 29.1992 18C28.9231 18 28.6992 17.7761 28.6992 17.5L28.6992 15.5C28.6992 15.2239 28.9231 15 29.1992 15Z",
    fill: "#F747C0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1992 32C29.4754 32 29.6992 32.2239 29.6992 32.5L29.6992 34.5C29.6992 34.7761 29.4754 35 29.1992 35C28.9231 35 28.6992 34.7761 28.6992 34.5L28.6992 32.5C28.6992 32.2239 28.9231 32 29.1992 32Z",
    fill: "#F747C0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0391 15C27.3152 15 27.5391 15.2239 27.5391 15.5L27.5391 17.5C27.5391 17.7761 27.3152 18 27.0391 18C26.7629 18 26.5391 17.7761 26.5391 17.5L26.5391 15.5C26.5391 15.2239 26.7629 15 27.0391 15Z",
    fill: "#F747C0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0391 32C27.3152 32 27.5391 32.2239 27.5391 32.5L27.5391 34.5C27.5391 34.7761 27.3152 35 27.0391 35C26.7629 35 26.5391 34.7761 26.5391 34.5L26.5391 32.5C26.5391 32.2239 26.7629 32 27.0391 32Z",
    fill: "#F747C0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8828 15C25.159 15 25.3828 15.2239 25.3828 15.5L25.3828 17.5C25.3828 17.7761 25.159 18 24.8828 18C24.6067 18 24.3828 17.7761 24.3828 17.5L24.3828 15.5C24.3828 15.2239 24.6067 15 24.8828 15Z",
    fill: "#F747C0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8828 32C25.159 32 25.3828 32.2239 25.3828 32.5L25.3828 34.5C25.3828 34.7761 25.159 35 24.8828 35C24.6067 35 24.3828 34.7761 24.3828 34.5L24.3828 32.5C24.3828 32.2239 24.6067 32 24.8828 32Z",
    fill: "#F747C0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7227 15C22.9988 15 23.2227 15.2239 23.2227 15.5L23.2227 17.5C23.2227 17.7761 22.9988 18 22.7227 18C22.4465 18 22.2227 17.7761 22.2227 17.5L22.2227 15.5C22.2227 15.2239 22.4465 15 22.7227 15Z",
    fill: "#F747C0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7227 32C22.9988 32 23.2227 32.2239 23.2227 32.5L23.2227 34.5C23.2227 34.7761 22.9988 35 22.7227 35C22.4465 35 22.2227 34.7761 22.2227 34.5L22.2227 32.5C22.2227 32.2239 22.4465 32 22.7227 32Z",
    fill: "#F747C0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 28.4474C36 28.7235 35.7761 28.9474 35.5 28.9474L33.5 28.9474C33.2239 28.9474 33 28.7235 33 28.4474C33 28.1712 33.2239 27.9474 33.5 27.9474L35.5 27.9474C35.7761 27.9474 36 28.1712 36 28.4474Z",
    fill: "#F747C0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 28.4474C18.9883 28.7235 18.7644 28.9474 18.4883 28.9474L16.4883 28.9474C16.2121 28.9474 15.9883 28.7235 15.9883 28.4474C15.9883 28.1712 16.2121 27.9474 16.4883 27.9474L18.4883 27.9474C18.7644 27.9474 18.9883 28.1712 18.9883 28.4474Z",
    fill: "#F747C0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 26.2895C36 26.5656 35.7761 26.7895 35.5 26.7895L33.5 26.7895C33.2239 26.7895 33 26.5656 33 26.2895C33 26.0133 33.2239 25.7895 33.5 25.7895L35.5 25.7895C35.7761 25.7895 36 26.0133 36 26.2895Z",
    fill: "#F747C0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 26.2895C18.9883 26.5656 18.7644 26.7895 18.4883 26.7895L16.4883 26.7895C16.2121 26.7895 15.9883 26.5656 15.9883 26.2895C15.9883 26.0133 16.2121 25.7895 16.4883 25.7895L18.4883 25.7895C18.7644 25.7895 18.9883 26.0133 18.9883 26.2895Z",
    fill: "#F747C0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 24.1316C36 24.4077 35.7761 24.6316 35.5 24.6316L33.5 24.6316C33.2239 24.6316 33 24.4077 33 24.1316C33 23.8554 33.2239 23.6316 33.5 23.6316L35.5 23.6316C35.7761 23.6316 36 23.8554 36 24.1316Z",
    fill: "#F747C0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 24.1316C18.9883 24.4077 18.7644 24.6316 18.4883 24.6316L16.4883 24.6316C16.2121 24.6316 15.9883 24.4077 15.9883 24.1316C15.9883 23.8554 16.2121 23.6316 16.4883 23.6316L18.4883 23.6316C18.7644 23.6316 18.9883 23.8554 18.9883 24.1316Z",
    fill: "#F747C0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 21.9737C36 22.2498 35.7761 22.4737 35.5 22.4737L33.5 22.4737C33.2239 22.4737 33 22.2498 33 21.9737C33 21.6976 33.2239 21.4737 33.5 21.4737L35.5 21.4737C35.7761 21.4737 36 21.6976 36 21.9737Z",
    fill: "#F747C0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9883 21.9737C18.9883 22.2498 18.7644 22.4737 18.4883 22.4737L16.4883 22.4737C16.2121 22.4737 15.9883 22.2498 15.9883 21.9737C15.9883 21.6976 16.2121 21.4737 16.4883 21.4737L18.4883 21.4737C18.7644 21.4737 18.9883 21.6976 18.9883 21.9737Z",
    fill: "#F747C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8708_63937",
    x: -12.4046,
    y: -12.9046,
    width: 75.8092,
    height: 75.8092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.4523
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8708_63937"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8708_63937",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8708_63937",
    x1: -19.5,
    y1: -31.0301,
    x2: 76.3258,
    y2: 8.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8708_63937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.1228 5.11512) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8708_63937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1381 33.463) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D73F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DFFCF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8708_63937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0444 -11.4273) rotate(47.2897) scale(27.9413 20.0791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItEssentialsIcon);
export default __webpack_public_path__ + "static/media/it_essentials_icon.168bff9b4732d15524ce6bfaa4d007ef.svg";
export { ForwardRef as ReactComponent };